module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "modal",
    staticClass: "btn",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#messageModal"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "messageModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-c",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header border-b-1"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.message.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-content-c"
  }, [_c('div', {
    staticClass: "mb-2",
    domProps: {
      "innerHTML": _vm._s(_vm.message.content)
    }
  }), _vm._v(" "), _vm._l((_vm.message.images), function(img, index) {
    return _c('div', {
      staticClass: "mb-1"
    }, [_c('img', {
      staticClass: "responsive-img",
      attrs: {
        "src": img.image_name,
        "data-toggle": "modal"
      }
    }), _vm._v(" "), _c('br'), _c('span', [_vm._v("圖片 " + _vm._s(index + 1))])])
  }), _vm._v(" "), _vm._l((_vm.message.link), function(url, index) {
    return _c('div', {
      staticClass: "mb-1"
    }, [_c('span', [_vm._v("連結" + _vm._s(index + 1) + "： "), _c('a', {
      attrs: {
        "href": url
      }
    }, [_vm._v(_vm._s(url))])])])
  }), _vm._v(" "), _c('small', {
    staticClass: "time"
  }, [_vm._v("系統通知 ｜ " + _vm._s(_vm.message.update_time))])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-default bt-c",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("關閉")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13956d75"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/nd-announcement-overlay.vue
// module id = 2324
// module chunks = 1